import * as core from '../../../../../../../core'

import { query } from './high-risk-table.query'

export const RESOURCE = {
  payload: {
    alias: 'high.risk.table',
    description: 'Table view of high-risk change impacts',
    name: 'High Risk Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
